/**
 * WordPress dependencies
 */
import { __, isRTL } from '@wordpress/i18n';
import { blockTable, category, formatListBullets, formatListBulletsRTL } from '@wordpress/icons';

/**
 * Internal dependencies
 */
import ViewTable from './view-table';
import ViewGrid from './view-grid';
import ViewList from './view-list';
import { LAYOUT_GRID, LAYOUT_LIST, LAYOUT_TABLE } from './constants';
export const VIEW_LAYOUTS = [{
  type: LAYOUT_TABLE,
  label: __('Table'),
  component: ViewTable,
  icon: blockTable
}, {
  type: LAYOUT_GRID,
  label: __('Grid'),
  component: ViewGrid,
  icon: category
}, {
  type: LAYOUT_LIST,
  label: __('List'),
  component: ViewList,
  icon: isRTL() ? formatListBulletsRTL : formatListBullets
}];
//# sourceMappingURL=layouts.js.map